<div class="bb-upload-container">
	<div class="file-drop-zone {{ theme }}-theme" [class.has-drop-zone]="!hideDropText"
		[ngClass]="{'large' : large, 'disabled': disabled, inline: inline, 'drop-zone-only': dropZoneOnly}"
		fileDroppable (onFilesDropped)="onFilesDropped($event)" (onDropEvent)="onDropEvent($event)">
		<div class="ripple" [class.animate]="rippleStyle.opacity" [ngStyle]="rippleStyle"></div>
		<div class="centered">
			<p *ngIf="showUploadIcon && !dropZoneOnly">
				<i class="far fa fa-cloud-arrow-up fa-2x"></i>
			</p>
			<p *ngIf="!hideDropText && !dropZoneOnly">
				{{ dropText || ( multi ? 'DROP_FILES_OR_UPLOAD' : 'DROP_FILE_OR_UPLOAD') | translate }}
			</p>
			<p *ngIf="dropTextRecommendation && !hideDropText && !dropZoneOnly" class="drop-recommendation">
				{{ dropTextRecommendation | translate }}
			</p>
			<p *ngIf="dropZoneOnly && theme !== 'light-v2'" class="drop-zone-only-text">
				drop files<br />
				to upload
			</p>

			<span class="button {{ theme }}-theme" [ngClass]="{'disabled': pendingUploads || !putRight || disabled}"
				[hidden]="dropZoneOnly || (!hideDropText && theme === 'light-v2')">
				<input [attr.disabled]="pendingUploads || !putRight || disabled ? '' : null" #button type="file"
					[attr.multiple]="multi ? '' : null" />

				<i class="fa fa-upload" [hidden]="pendingUploads"></i>
				<i class="fa fa-circle-o-notch fa-spin" [hidden]="!pendingUploads"></i>

				<span [hidden]="pendingUploads">{{ uploadText || ( multi ? 'SELECT_FILES' : 'UPLOAD_FILE') | translate
					}}</span>
				<span [hidden]="!pendingUploads">{{ ( multi ? 'UPLOADING_FILES' : 'UPLOADING_FILE') | translate
					}}</span>

			</span>
		</div>
	</div>
	<div *ngIf="recommendationsTable">
		<div class="recommendations">
			<a (click)="showRecommendations = !showRecommendations">
				{{ 'UPLOAD_RECOMMENDATIONS' | translate }}
			</a>
		</div>
		<ng-container *ngIf="showRecommendations">
			<bb-table-container>
				<bb-table-header>
					<bb-table-header-cell>{{ 'VIDEO_STREAM' | translate }}</bb-table-header-cell>
					<bb-table-header-cell>480p (SD)</bb-table-header-cell>
					<bb-table-header-cell>720p (HD)</bb-table-header-cell>
					<bb-table-header-cell>1080p (HD)</bb-table-header-cell>
				</bb-table-header>
				<bb-table-row>
					<bb-table-cell><label>{{ 'CODEC' | translate }}</label></bb-table-cell>
					<bb-table-cell>h.264</bb-table-cell>
					<bb-table-cell>h.264</bb-table-cell>
					<bb-table-cell>h.264</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'PROFILE' | translate }}</label></bb-table-cell>
					<bb-table-cell>{{ 'MAIN_PROFILE' | translate }}</bb-table-cell>
					<bb-table-cell>{{ 'HIGH_PROFILE' | translate }}</bb-table-cell>
					<bb-table-cell>{{ 'HIGH_PROFILE' | translate }}</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'SCANNING' | translate }}</label></bb-table-cell>
					<bb-table-cell>Progressive (not interlaced)*</bb-table-cell>
					<bb-table-cell>Progressive (not interlaced)*</bb-table-cell>
					<bb-table-cell>Progressive (not interlaced)*</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'BITRATE' | translate }}</label></bb-table-cell>
					<bb-table-cell>2.5-5 Mbps</bb-table-cell>
					<bb-table-cell>5-10 Mbps</bb-table-cell>
					<bb-table-cell>10-20 Mbps</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'ASPECT_RATIO' | translate }}</label></bb-table-cell>
					<bb-table-cell>Any, do not letterbox</bb-table-cell>
					<bb-table-cell>Any, do not letterbox</bb-table-cell>
					<bb-table-cell>Any, do not letterbox</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'FRAMERATE' | translate }}</label></bb-table-cell>
					<bb-table-cell>Any (input = output)</bb-table-cell>
					<bb-table-cell>Any (input = output)</bb-table-cell>
					<bb-table-cell>Any (input = output)</bb-table-cell>
				</bb-table-row>
			</bb-table-container>

			<p>*Interlaced content should be deïnterlaced before uploading.</p>

			<bb-table-container>
				<bb-table-header>
					<bb-table-header-cell>{{ 'AUDIO_STREAM' | translate }}</bb-table-header-cell>
					<bb-table-header-cell>{{ 'MONO' | translate }}</bb-table-header-cell>
					<bb-table-header-cell>{{ 'STEREO' | translate }}</bb-table-header-cell>
					<bb-table-header-cell>5.1</bb-table-header-cell>
				</bb-table-header>
				<bb-table-row>
					<bb-table-cell><label>{{ 'CODEC' | translate }}</label></bb-table-cell>
					<bb-table-cell>AAC (Advanced Audio Codec)</bb-table-cell>
					<bb-table-cell>AAC</bb-table-cell>
					<bb-table-cell>AAC</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'SAMPLE_RATE' | translate }}</label></bb-table-cell>
					<bb-table-cell>48 kHz</bb-table-cell>
					<bb-table-cell>48 kHz</bb-table-cell>
					<bb-table-cell>48 kHz</bb-table-cell>
				</bb-table-row>
				<bb-table-row>
					<bb-table-cell><label>{{ 'BITRATE' | translate }}</label></bb-table-cell>
					<bb-table-cell>192 kbps</bb-table-cell>
					<bb-table-cell>320 kbps</bb-table-cell>
					<bb-table-cell>512 kbps</bb-table-cell>
				</bb-table-row>
			</bb-table-container>
		</ng-container>
	</div>
</div>
